import { Directive, ElementRef, EventEmitter, Output, OnDestroy, HostListener } from '@angular/core';

@Directive({
    selector: '[appClickOutside]',
    standalone: false
})
export class ClickOutsideDirective implements OnDestroy {
  @Output() appClickOutside = new EventEmitter<Event>();

  constructor(private _elementRef: ElementRef) {}

  @HostListener('document:click', ['$event'])
  public onDocumentClick(event: Event): void {
    const target = event.target as HTMLElement;
    if (!this._elementRef.nativeElement.contains(target)) {
      this.appClickOutside.emit(event);
    }
  }

  ngOnDestroy(): void {
    this.appClickOutside.complete();
  }
}
